// eslint-disable-next-line @typescript-eslint/naming-convention
export const options = [{
  title: 'borderTop',
  out: 'M12 5v7H4V5H2v9h12V5h-2z',
  in: 'M14 2v2H2V2z'
}, {
  title: 'borderRight',
  out: 'M11 4H4v8h7v2H2V2h9v2z',
  in: 'M14 2h-2v12h2z'
}, {
  title: 'borderBottom',
  out: 'M4 11V4h8v7h2V2H2v9h2z',
  in: 'M2 14v-2h12v2z'
}, {
  title: 'borderLeft',
  out: 'M5 4h7v8H5v2h9V2H5v2z',
  in: 'M2 2h2v12H2z'
}, {
  title: 'border',
  out: 'M14 2H2v12h12V2zm-2 2H4v8h8V4z'
}];
export const borderOptions = {
  'aria-hidden': 'true',
  focusable: 'false',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16'
};
export const pathAttrs = {
  opacity: '.4',
  'fill-rule': 'evenodd',
  'clip-rule': 'evenodd'
};
// radius
// eslint-disable-next-line @typescript-eslint/naming-convention
export const wholeBorderPath = 'M5 2a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3H5zm0 2a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1H5z';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const concreteBorderPath = 'M5 2a3 3 0 00-3 3v2h2V5a1 1 0 011-1h2V2H5zm6 0a3 3 0 013 3v2h-2V5a1 1 0 00-1-1H9V2h2zM5 14a3 3 0 01-3-3V9h2v2a1 1 0 001 1h2v2H5zm6 0a3 3 0 003-3V9h-2v2a1 1 0 01-1 1H9v2h2z';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const borderFieldsArr = ['border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight'];
// eslint-disable-next-line @typescript-eslint/naming-convention
export const borderRadiusFieldsArr = ['border', 'borderTopLeft', 'borderTopRight', 'borderBottomLeft', 'borderBottomRight'];
// eslint-disable-next-line @typescript-eslint/naming-convention
export const radiusOptions = [{
  title: 'TopLeft',
  out: 'M9 2h5v5h-2V4H9V2zm3 7h2v5H9v-2h3V9zM2 14V9h2v3h3v2H2z',
  in: 'M5 2a3 3 0 00-3 3v2h2V5a1 1 0 011-1h2V2H5z'
}, {
  title: 'TopRight',
  out: 'M14 9v5H9v-2h3V9h2zm-7 3v2H2V9h2v3h3zM2 2h5v2H4v3H2V2z',
  in: 'M14 5a3 3 0 00-3-3H9v2h2a1 1 0 011 1v2h2V5z'
}, {
  title: 'BottomLeft',
  out: 'M2 7V2h5v2H4v3H2zm7-3V2h5v5h-2V4H9zm5 10H9v-2h3V9h2v5z',
  in: 'M2 11a3 3 0 003 3h2v-2H5a1 1 0 01-1-1V9H2v2z'
}, {
  title: 'BottomRight',
  out: 'M7 14H2V9h2v3h3v2zM4 7H2V2h5v2H4v3zm10-5v5h-2V4H9V2h5z',
  in: 'M11 14a3 3 0 003-3V9h-2v2a1 1 0 01-1 1H9v2h2z'
}];
export function getUnit(sizeStr) {
  var _sizeStr$match;
  if (!sizeStr || typeof sizeStr !== 'string') return 'px';
  return ((_sizeStr$match = sizeStr.match(/([a-z]+)\s*$/i)) === null || _sizeStr$match === void 0 ? void 0 : _sizeStr$match[1]) || 'px';
}
export function getNumber(sizeStr, defaultVal = '0') {
  if (!sizeStr || typeof sizeStr !== 'string') return defaultVal;
  const unit = getUnit(sizeStr);
  return `${['auto', 'none'].includes(unit) ? unit : parseFloat(sizeStr || '')}`;
}
//# sourceMappingURL=borderUtils.js.map
